import store from '../store'

class AppHelper {
  displayErrors(err) {
    let message = 'Unknown error occurred. Please try again.'
    if (err.response) {
      // client received an error response (5xx, 4xx)
      message = err.response.data.message
    } else if (err.request) {
      // client never received a response, or request never left
      message = 'Network error. Please try again.'
    }
    store.commit('setSnackbarColor', 'error')
    store.commit('setSnackbarMsg', message)
    store.commit('setShowSnackbar', true)
  }
}

const appHelper = new AppHelper()

export const displayErrors = appHelper.displayErrors